// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoBlock_container__2_VSX"};